// Header component functionality
class Header {
  constructor() {
    this.header = document.querySelector('[data-js="header"]');
    this.menuToggle = document.querySelector('[data-js="menu-toggle"]');
    
    if (!this.header) return;
    
    this.init();
  }
  
  init() {
    this.bindEvents();
    this.handleScroll();
  }
  
  bindEvents() {
    // Sticky header on scroll
    window.addEventListener('scroll', this.handleScroll.bind(this));
    
    // Mobile menu toggle
    if (this.menuToggle) {
      this.menuToggle.addEventListener('click', this.toggleMobileMenu.bind(this));
    }
    
    // Smooth scroll for navigation links
    const navLinks = this.header.querySelectorAll('a[href^="#"]');
    navLinks.forEach(link => {
      link.addEventListener('click', this.handleSmoothScroll.bind(this));
    });
  }
  
  handleScroll() {
    const scrollY = window.scrollY;
    
    if (scrollY > 100) {
      this.header.classList.add('header--sticky');
    } else {
      this.header.classList.remove('header--sticky');
    }
  }
  
  toggleMobileMenu() {
    const nav = document.querySelector('.header__nav');
    const isOpen = this.menuToggle.classList.contains('header__menu-toggle--open');
    
    if (isOpen) {
      this.menuToggle.classList.remove('header__menu-toggle--open');
      nav.classList.remove('header__nav--open');
      document.body.style.overflow = '';
    } else {
      this.menuToggle.classList.add('header__menu-toggle--open');
      nav.classList.add('header__nav--open');
      document.body.style.overflow = 'hidden';
    }
  }
  
  handleSmoothScroll(e) {
    const href = e.target.getAttribute('href');
    
    if (href && href.startsWith('#')) {
      e.preventDefault();
      
      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        const headerHeight = this.header.offsetHeight;
        const targetPosition = targetElement.offsetTop - headerHeight - 20;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
        
        // Закрываем мобильное меню после клика по ссылке
        const nav = document.querySelector('.header__nav');
        if (nav.classList.contains('header__nav--open')) {
          this.toggleMobileMenu();
        }
      }
    }
  }
}

export { Header };
